import { render, staticRenderFns } from "./BlockTitle.vue?vue&type=template&id=e2fe1d0e&scoped=true&"
import script from "./BlockTitle.vue?vue&type=script&lang=ts&"
export * from "./BlockTitle.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTitle.vue?vue&type=style&index=0&id=e2fe1d0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fe1d0e",
  null
  
)

export default component.exports